import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ebd6753"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "Configuration_type",
    style: _normalizeStyle('width:' + _ctx.width)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass([item.type == _ctx.typeid ? '_type-son_color _type-son' : '_type-son']),
        onClick: ($event: any) => (_ctx.typechange(item.type))
      }, _toDisplayString(item.name), 11, _hoisted_1))
    }), 128))
  ], 4))
}